import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { Onboarding } from './models/onboarding.model';
import { getOnboarding } from './requests/onboarding.request';

export const useGetOnboarding = (partnerId: string) => {
  const [onboarding, setOnboarding] = useState<Onboarding>(new Onboarding());

  const { request: fetchGetOnboarding } = useRequest(async () => {
    const onboardingData = await getOnboarding(partnerId);
    setOnboarding(onboardingData);
    return onboardingData;
  });

  return { onboarding, fetchGetOnboarding };
};
